import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedFacets,
  selectDisplayedFacetValues,
  changeMultiFacet,
  clearAlwaysApply
} from "../modules/search/selectedFacets";

export function useSelectedFacets() {
  const dispatch = useDispatch();

  const selectedFacets = useSelector(selectSelectedFacets);
  const displayedFacetValues = useSelector(selectDisplayedFacetValues);

  const onChangeMultiFacet = useCallback(
    toggledFacets => {
      dispatch(changeMultiFacet(toggledFacets));
    },
    [dispatch]
  );

  const onClearAlwaysApply = useCallback(
    facetId => {
      dispatch(clearAlwaysApply(facetId));
    },
    [dispatch]
  );

  return {
    selectedFacets,
    displayedFacetValues,
    changeMultiFacet: onChangeMultiFacet,
    clearAlwaysApply: onClearAlwaysApply
  };
}
